import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CloakLoading from '../CloakLoading';
import classNames from 'classnames';
import FlexGrid, { FlexGridColumn } from '../FlexGrid';
import Button from '../Button';
import { LOADING_DELAY } from './const';
import classes from './styles/index.module.scss';

export const ComponentCloakLoading = ({
	className,
	error,
	retry,
	timedOut,
	spinnerWithDelay,
	noBackground,
	loadingDelay,
}) => {
	const [spinnerVisibility, setSpinnerVisibility] = useState(!spinnerWithDelay);
	const componentClasses = classNames(classes.componentCloakLoading, className);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (!spinnerVisibility) {
				setSpinnerVisibility(true);
			}
		}, loadingDelay || LOADING_DELAY);

		return () => {
			clearTimeout(timer);
		};
	}, [loadingDelay, spinnerVisibility, setSpinnerVisibility]);

	if (error) {
		return (
			<FlexGrid
				center
				hrCenter
				className={componentClasses}
				dataTestId='componentCloakLoading__error'
			>
				<FlexGridColumn>
					Oops
					<Button onClick={retry}>Retry loading</Button>
				</FlexGridColumn>
			</FlexGrid>
		);
	}

	if (timedOut) {
		return (
			<FlexGrid
				center
				hrCenter
				className={componentClasses}
				dataTestId='componentCloakLoading__timedOut'
			>
				<FlexGridColumn>
					Taking a long time...
					<Button onClick={retry}>Retry loading</Button>
				</FlexGridColumn>
			</FlexGrid>
		);
	}

	if (!spinnerVisibility) {
		return null;
	}

	return (
		<div
			className={componentClasses}
			data-testid='componentCloakLoading'
		>
			<CloakLoading noBackground={noBackground} />
		</div>
	);
};

ComponentCloakLoading.propTypes = {
	spinnerWithDelay: PropTypes.bool,
	noBackground: PropTypes.bool,
};

ComponentCloakLoading.defaultProps = {
	spinnerWithDelay: false,
};

export default ComponentCloakLoading;
